import * as yup from "yup";

const p_wRegex = /^(?=.{8,})(?=.*[a-z])(?=.*[~`!@#$%^&*()_+=\-[\]{}|;:'",.<>/?\\]).*$/;

export const loginSchema = yup.object().shape({
  email: yup.string().email("Email chưa đúng định dạng").required("Trường này là bắt buộc"),
  password: yup.string()
    // .matches(p_wRegex, "Tối thiểu 8 ký tự, có it nhất 1 ký tự viết thường, hoa và ký tự đặc biệt")
    .required("Trường này là bắt buộc"),
});

export const login2FASchema = yup.object().shape({
  verifyCode: yup.string()
    .required("Trường này là bắt buộc"),
});

export const updateUserSchema = yup.object().shape({
  FullName: yup.string().required("Full name is required"),
  FirstName: yup.string().required("First name is required"),
  LastName: yup.string().required("Last name is required"),
  Email: yup.string().email("Invalid email format").required("Email is required"),
  DateOfBirth: yup.string().required("Date of birth is required"),
  Sex: yup.boolean().required("Sex is required"),
  Hometown: yup.string().required("Hometown is required"),
  City: yup.string().required("City is required"),
  Country: yup.string().required("Country is required"),
  PhoneNumber: yup.string().required("Phone number is required"),
  Description: yup.string().nullable(),
});

export const register2FASchema = yup.object().shape({
  verifyCode: yup.string().required("Code is required"),
})

export const disable2FASchema = yup.object().shape({
  password: yup.string()
    .required("Trường này là bắt buộc"),
});

